import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import '@bw/alloy-styles/dist/alloyStyles.css';
import './global.scss';

import FeatureFlagsProvider from './FeatureFlagsProvider';
import PassportRoutes from './Routes';
import ApiProvider from './ApiProvider';
import './datadog';

/** Top level application component. */
const App = () => (
  <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
    <ApiProvider>
      <FeatureFlagsProvider>
        <PassportRoutes />
      </FeatureFlagsProvider>
    </ApiProvider>
  </BrowserRouter>
);
export default App;
